import React from "react";
import "./ChantSelect.css";
import { Select } from "antd";
import { Controller } from "react-hook-form";

const ChantSelect = ({
  label,
  control,
  name,
  rules,
  options = [],
  placeholder,
  allowClear = false,
  showSearch = false,
  mode,
  onChange: customOnChange,
  disabled,
  value,
  defaultValue,
  formattedOptions,
  required,
  helpTooltip,
  helpText,
  ...props
}) => {
  const handleChange = (value) => {
    if (customOnChange) {
      customOnChange(value);
    }
  };

  // Use formattedOptions if provided, otherwise use options
  const selectOptions = formattedOptions || options;

  // If control and name are provided, use Controller pattern
  if (control && name) {
    return (
      <div className="chant-select-container">
        {label && (
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <label className="chant-select-label">
              {label}{" "}
              {required ? <span style={{ color: "red" }}>*</span> : null}
            </label>
            {helpTooltip && <div>{helpTooltip}</div>}
          </div>
        )}
        <div className="chant-select-wrapper">
          <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Select
                  {...field}
                  style={{ width: "100%" }}
                  placeholder={placeholder}
                  allowClear={allowClear}
                  popupMatchSelectWidth={false}
                  showSearch={showSearch}
                  mode={mode}
                  status={error ? "error" : ""}
                  value={field.value || undefined}
                  disabled={disabled}
                  options={selectOptions}
                  onChange={(value) => {
                    // Call React Hook Form's onChange first
                    field.onChange(value);
                    // Then call custom onChange if provided
                    if (customOnChange) {
                      customOnChange(value);
                    }
                  }}
                  {...props}
                />
                {error && (
                  <div className="chant-select-error">{error.message}</div>
                )}
              </div>
            )}
          />
        </div>
        {helpText && <div className="chant-select-help">{helpText}</div>}
      </div>
    );
  }

  // Otherwise, use the regular pattern for backward compatibility
  return (
    <div className="chant-select-container">
      {label && (
        <label className="chant-select-label">
          {label} {required ? <span style={{ color: "red" }}>*</span> : null}
        </label>
      )}
      <div className="chant-select-wrapper">
        <Select
          style={{ width: "100%" }}
          placeholder={placeholder}
          allowClear={allowClear}
          showSearch={showSearch}
          options={selectOptions}
          mode={mode}
          popupMatchSelectWidth={false}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          onChange={handleChange}
          {...props}
        />
      </div>
      {helpText && <div className="chant-select-help">{helpText}</div>}
    </div>
  );
};

export default ChantSelect;
